/**
 * @license
 * Copyright William Goeller. All Rights Reserved.
 * Licensed under the Apache License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyD20QOrRgJSOQ2ZQx2U3v4ATpwn_T-mmM8',
    authDomain: 'ohqueue-dev.firebaseapp.com',
    databaseURL: 'https://ohqueue-dev.firebaseio.com',
    projectId: 'ohqueue-dev',
    storageBucket: 'ohqueue-dev.appspot.com',
    messagingSenderId: '888447489951',
    appId: '1:888447489951:web:afe4904fc14f93d70ecfaa',
    measurementId: 'G-PYZ0YC5T0T',
  },
};
